import { render } from "./BackLink.vue?vue&type=template&id=7e3f749a&scoped=true"
import script from "./BackLink.vue?vue&type=script&lang=js"
export * from "./BackLink.vue?vue&type=script&lang=js"

import "./BackLink.vue?vue&type=style&index=0&id=7e3f749a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e3f749a"]])

export default __exports__